export type InputFormatType = 'currency' | 'percent';

export const parseCurrencyInput = (value: string | number, type: InputFormatType = 'currency'): number => {
    const stringValue = typeof value === 'number' ? value.toString() : value;

    if (type === 'currency') {
        return parseFloat(stringValue?.replace(/,/g, '')) || 0;
    }

    if (type === 'percent') {
        return parseFloat(stringValue?.replace(',', '.')) || 0;
    }

    return 0;
};

export const formatInvestmentAmount = (value: number): string => {
    return value.toLocaleString('en-UK', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
};
